import { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SimpleReactValidator from 'simple-react-validator';

import ToggleButton from 'react-toggle-button';

import { nextThirdSection, returnSection } from '../../../store/actions/order';
import { errorMessage } from '../../../utils/message';
import { canTypeForNumInput } from '../../../utils/numbers';
import { isPersianWithNumber } from '../../../utils/persianLatter';
import { toEnglishNumbers } from '../../../utils/datePicker';

const GoodsInfo = () => {
   const dispatch = useDispatch();
   const { section, packSizePackages } = useSelector((state) => state.order);

   const [force, forceUpdate] = useState(true);
   const [registerOrder, setRegisterOrder] = useState({ packes: [] });
   const [title, setTitle] = useState('');
   const [typeAndSize, setTypeAndSize] = useState({ title: '' });
   const [size, setSize] = useState({ height: '', width: '', length: '' });
   const [weight, setWeight] = useState('');
   const [number, setNumber] = useState('');
   const [isFragile, setIsFragile] = useState(false);
   const [description, setDescription] = useState('');
   const [showErrorMsg, setShowErrorMsg] = useState(true);

   const NoState = useRef(0);
   const validator = useRef(
      new SimpleReactValidator({
         messages: {
            required: 'پر کردن این فیلد الزامی میباشد',
            min: 'کمتر از 2 حرف نمی تواند باشد',
         },
         validators: {
            descValid: {
               message: 'توضیحات معتبر نیستند',
               rule: (val) => {
                  const add = isPersianWithNumber(val);
                  return add;
               },
               required: true,
            },
            titleValid: {
               message: 'عنوان معتبر نیستند',
               rule: (val) => {
                  const add = isPersianWithNumber(val);
                  return add;
               },
               required: true,
            },
         },
         element: (message) => <div style={{ color: 'red', fontSize: '1.3rem' }}>{message}</div>,
      })
   );

   const styles = {
      thumbStyle: {
         width: '25px',
         height: '25px',
      },
      trackStyle: {
         width: '45px',
         height: '15px',
      },
   };

   const handleChange = (e, type) => {
      let x;
      const value = toEnglishNumbers(e.target.value + '');

      switch (type) {
         case 'title':
            setTitle(value);
            break;
         case 'typeAndSize':
            const filterSize =
               value === 'سایر'
                  ? { id: 0, length: '', width: '', height: '' }
                  : packSizePackages.filter((item) => item.title === value)[0];
            setTypeAndSize({
               id: filterSize.id,
               title: value,
               size: {
                  length: filterSize.length,
                  width: filterSize.width,
                  height: filterSize.height,
               },
            });
            setSize({
               height: filterSize.height,
               length: filterSize.length,
               width: filterSize.width,
            });
            break;
         case 'otherTypeAndSize':
            setSize((prev) => ({ ...prev, [e.target.name]: value }));
            setTypeAndSize((prev) => ({
               ...prev,
               size: { ...prev.size, [e.target.name]: value },
            }));
            break;
         case 'number':
            setNumber(value);
            break;
         case 'weight':
            setWeight(value);
            break;
         case 'description':
            setDescription(value);
            break;
         default:
            break;
      }
   };
   const handleAdd = () => {
      setShowErrorMsg(true);
      if (validator.current.allValid()) {
         if (NoState.current + Number(number) > 999) {
            return errorMessage('بیشتر از حد مجاز بسته ثبت شده');
         } else {
            if (number && weight && title && typeAndSize) {
               const found = registerOrder.packes.findIndex(
                  (item) =>
                     item.typeAndSize.id === typeAndSize.id &&
                     item.weight === weight &&
                     item.title === title &&
                     item.isFragile === isFragile
               );
               if (found === -1) {
                  let myNumNow = `000`;
                  let NONow = [];
                  for (let i = NoState.current + 1; i <= NoState.current + Number(number); i++) {
                     switch (i.toString().length) {
                        case 1:
                           myNumNow = `00${i}`;
                           break;
                        case 2:
                           myNumNow = `0${i}`;
                           break;
                        default:
                           myNumNow = `${i}`;
                           break;
                     }
                     NONow.push(myNumNow);
                  }
                  setRegisterOrder((prev) => ({
                     ...prev,
                     packes: [
                        ...prev.packes,
                        {
                           typeAndSize: { ...typeAndSize },
                           weight,
                           number,
                           isFragile,
                           description,
                           title,
                           NO: NONow,
                        },
                     ],
                  }));
                  NoState.current += Number(number);
               } else {
                  let myNumNow = `000`;
                  let NOCount = 0;
                  const arrayPackagesUpdate = [...registerOrder.packes];
                  for (let j = 0; j < arrayPackagesUpdate.length; j++) {
                     if (j === found) {
                        arrayPackagesUpdate[found].number =
                           +arrayPackagesUpdate[found].number + +number;
                     }
                     let NONow = [];
                     for (let i = NOCount + 1; i <= NOCount + +arrayPackagesUpdate[j].number; i++) {
                        switch (i.toString().length) {
                           case 1:
                              myNumNow = `00${i}`;
                              break;
                           case 2:
                              myNumNow = `0${i}`;
                              break;
                           default:
                              myNumNow = `${i}`;
                        }
                        NONow.push(myNumNow);
                     }
                     arrayPackagesUpdate[j].NO = NONow;
                     setRegisterOrder({
                        ...registerOrder,
                        packes: arrayPackagesUpdate,
                     });
                     NOCount += +arrayPackagesUpdate[j].number;
                  }
                  NoState.current = NOCount;
               }
               setTitle('');
               setTypeAndSize({ title: '' });
               setSize({ height: '', width: '', length: '' });
               setWeight('');
               setNumber('');
               setIsFragile(false);
               setDescription('');
               setShowErrorMsg(false);
            } else {
               errorMessage('لطفا اطلاعات مورد نیاز را تکمیل نمایید.');
            }
         }
      } else {
         validator.current.showMessages();
         forceUpdate(!force);
      }
   };
   const handleDelete = (i) => {
      const updateRegisterArray = registerOrder.packes.filter((pack, index) => index !== i);
      let countArray = 0;
      for (let j = 0; j < updateRegisterArray.length; j++) {
         let myNumNow = `000`;
         let NONow = [];
         for (
            let i = countArray + 1;
            i <= Number(updateRegisterArray[j].number) + countArray;
            i++
         ) {
            switch (i.toString().length) {
               case 1:
                  myNumNow = `00${i}`;
                  break;
               case 2:
                  myNumNow = `0${i}`;
                  break;
               default:
                  myNumNow = `${i}`;
            }
            NONow.push(myNumNow);
         }
         updateRegisterArray[j].NO = NONow;
         countArray += Number(updateRegisterArray[j].number);
      }
      NoState.current = countArray;
      setRegisterOrder({ ...registerOrder, packes: updateRegisterArray });
   };
   const handleNext = () => {
      if (registerOrder.packes.length > 0) {
         dispatch(nextThirdSection(registerOrder.packes));
      } else {
         errorMessage('اطلاعات کالای خود را وارد کنید');
      }
   };

   return (
      <div
         className={section === 3 ? 'progresstabs__content active-nav' : 'progresstabs__content'}
         style={{ minHeight: 'unset' }}
      >
         <h1 className='progresstabs__content-title'>مشخصات کالا</h1>
         <div className='progresstabs__content-goods'>
            <div className='progresstabs__content-goods-info'>
               <label className='progresstabs__content-goods-lable' htmlFor='type-select'>
                  عنوان
                  <input
                     onChange={(e) => handleChange(e, 'title')}
                     name='title'
                     type='text'
                     className='progresstabs__content-goods-input progresstabs__content-goods-input--weight'
                     value={title}
                  />
                  {showErrorMsg &&
                     validator.current.message('title', title, 'required|titleValid|min:2')}
               </label>
               <label className='progresstabs__content-goods-lable' htmlFor='type-select'>
                  نوع
                  <select
                     id='type-select'
                     className='progresstabs__content-goods-input'
                     style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}
                     name='typeAndSize'
                     value={typeAndSize.title}
                     onChange={(e) => handleChange(e, 'typeAndSize')}
                  >
                     <option hidden>نوع و ابعاد مورد نظر</option>
                     {packSizePackages.map((item) => (
                        <option key={item.id} value={item.title}>
                           {`${item.title}`}
                        </option>
                     ))}
                     <option value='سایر'>سایر</option>
                  </select>
                  <div className='progresstabs__content-goods-lable-size'>
                     <label>
                        طول
                        <input
                           type='text'
                           name='length'
                           value={size.length}
                           onChange={(e) => handleChange(e, 'otherTypeAndSize')}
                           onKeyDown={(e) => canTypeForNumInput(e)}
                           readOnly={typeAndSize.title === 'سایر' ? false : true}
                           disabled={typeAndSize.title === 'سایر' ? false : true}
                           autoComplete='off'
                        />
                     </label>
                     <label>
                        عرض
                        <input
                           type='text'
                           name='width'
                           value={size.width}
                           onChange={(e) => handleChange(e, 'otherTypeAndSize')}
                           onKeyDown={(e) => canTypeForNumInput(e)}
                           readOnly={typeAndSize.title === 'سایر' ? false : true}
                           disabled={typeAndSize.title === 'سایر' ? false : true}
                           autoComplete='off'
                        />
                     </label>
                     <label>
                        ارتفاع
                        <input
                           type='text'
                           name='height'
                           value={size.height}
                           onChange={(e) => handleChange(e, 'otherTypeAndSize')}
                           onKeyDown={(e) => canTypeForNumInput(e)}
                           readOnly={typeAndSize.title === 'سایر' ? false : true}
                           disabled={typeAndSize.title === 'سایر' ? false : true}
                           autoComplete='off'
                        />
                     </label>
                  </div>
                  {showErrorMsg &&
                     validator.current.message('typeAndSize', typeAndSize.title, 'required')}
               </label>
               <label className='progresstabs__content-goods-lable' htmlFor='type-select'>
                  وزن
                  <input
                     type='text'
                     className='progresstabs__content-goods-input progresstabs__content-goods-input--weight'
                     name='weight'
                     value={weight}
                     onChange={(e) => handleChange(e, 'weight')}
                     onKeyDown={(e) => canTypeForNumInput(e)}
                     autoComplete='off'
                  />
                  <span>کیلوگرم</span>
                  {showErrorMsg && validator.current.message('weight', weight, 'required')}
               </label>
               <label className='progresstabs__content-goods-lable' htmlFor='type-select'>
                  تعداد
                  <input
                     type='text'
                     className='progresstabs__content-goods-input'
                     name='number'
                     value={number}
                     onChange={(e) => handleChange(e, 'number')}
                     onKeyDown={(e) => canTypeForNumInput(e)}
                     autoComplete='off'
                  />
                  {showErrorMsg && validator.current.message('number', number, 'required')}
               </label>
               <label type='checkbox' className='progresstabs__content-goods-toggle'>
                  شکستنی
                  <ToggleButton
                     inactiveLabel={''}
                     activeLabel={''}
                     colors={{
                        inactiveThumb: {
                           base: '#f8f7f8',
                        },
                        activeThumb: {
                           base: '#fe5900',
                        },
                        inactive: {
                           base: '#edecef',
                           hover: '#edecef',
                        },
                        active: {
                           base: '#4a4752',
                           hover: '#4a4752',
                        },
                     }}
                     trackStyle={styles.trackStyle}
                     thumbStyle={styles.thumbStyle}
                     thumbAnimateRange={[0, 36]}
                     // thumbIcon={<ThumbIcon />}
                     value={isFragile}
                     // ={(e) => handleChange(e, "isFragile")}
                     onToggle={(e) => setIsFragile((prev) => !prev)}
                  />
               </label>
               <label
                  className='progresstabs__content-goods-lable progresstabs__content-goods-lable--description'
                  htmlFor='type-select'
               >
                  توضیحات
                  <textarea
                     onChange={(e) => handleChange(e, 'description')}
                     name='description'
                     className='progresstabs__content-goods-textarea progresstabs__content-goods-textarea--description'
                     value={description}
                  />
                  {showErrorMsg && validator.current.message('description', description, 'min:2')}
               </label>
            </div>
            <div className='progresstabs__content-add'>
               <button className='progresstabs__content-add-btn' onClick={handleAdd}>
                  <p className='progresstabs__content-add-text'>افزودن کالا</p>
                  <img className='progresstabs__content-add-img' src='./img/plus.svg' alt='plus' />
               </button>
            </div>
         </div>
         {registerOrder.packes.length !== 0 && (
            <>
               <h1 className='progresstabs__content-title' style={{ paddingTop: '30px' }}>
                  کالاهای شما
               </h1>
               <div className='progresstabs__content-boxes'>
                  {registerOrder.packes.map((item, index) => (
                     <div key={index} className='progresstabs__content-container'>
                        <div className='progresstabs__content-items'>
                           <p className='progresstabs__content-items-item'>{item.title}</p>
                           <p className='progresstabs__content-items-item'>
                              {item.typeAndSize.title}
                           </p>
                           <p className='progresstabs__content-items-item'>
                              {`${item.typeAndSize.size.height}*${item.typeAndSize.size.length}*${item.typeAndSize.size.width}`}
                           </p>
                           <p className='progresstabs__content-items-item'>{item.number} عدد</p>
                           <p className='progresstabs__content-items-item'>{item.weight} (kg)</p>
                           <p className='progresstabs__content-items-item'>
                              {item.isFragile ? 'شکستنی' : '------'}
                           </p>
                           <div
                              className='progresstabs__content-items-edit'
                              onClick={() => handleDelete(index)}
                           >
                              <img
                                 className='progresstabs__content-items-img'
                                 src='./img/delete.png'
                                 alt=''
                              />
                           </div>
                        </div>
                     </div>
                  ))}
               </div>
            </>
         )}
         <div className='progresstabs__content-buttons'>
            <button
               className='btn btn--secondary return-btn'
               onClick={() => dispatch(returnSection())}
            >
               بازگشت
            </button>
            <button className='btn btn--secondary next-btn' onClick={handleNext}>
               تایید و ادامه
            </button>
         </div>
      </div>
   );
};

export default GoodsInfo;
